var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10360_10449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0144 21.862L27.4549 23.7465L19.2996 17.0534V33.3313H17.2202V17.0534L9.06498 23.7465L7.50541 21.862L15.0758 15.6562H0V29.5949C0 31.6743 1.68953 33.3313 3.73646 33.3313H41.231C43.3105 33.3313 44.9675 31.6418 44.9675 29.5949V15.6562H21.444L29.0144 21.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18412 9.12647C3.18412 6.36473 5.42599 4.12286 8.18773 4.12286C9.45487 4.12286 10.6245 4.57773 11.5343 5.4225L17.2202 10.8485V0.90625H3.73646C1.68953 0.90625 0 2.59578 0 4.64271V13.5777H5.97834C4.3213 12.7655 3.18412 11.0759 3.18412 9.09398V9.12647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18764 6.52734C6.75803 6.52734 5.62085 7.69702 5.62085 9.09413C5.62085 10.4912 6.79052 11.6609 8.18764 11.6609H14.6208L9.90966 7.17716C9.42229 6.72229 8.83746 6.52734 8.18764 6.52734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.231 0.90625H19.2996V10.816L24.953 5.45499C25.9277 4.57773 27.0974 4.12286 28.3645 4.12286C31.1263 4.12286 33.3682 6.36473 33.3682 9.12647C33.3682 11.1084 32.231 12.7979 30.5739 13.6102H44.9674V4.64271C44.9674 2.56329 43.2779 0.90625 41.231 0.90625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3646 6.52734C27.7148 6.52734 27.13 6.75478 26.6751 7.17716L21.9314 11.6934H28.3646C29.7942 11.6934 30.9314 10.5237 30.9314 9.12662C30.9314 7.72951 29.7617 6.55983 28.3646 6.55983V6.52734Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10360_10449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 32.4585,
    fill: "white",
    transform: "translate(0 0.90625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.4a45c22c.svg";
export { ForwardRef as ReactComponent };